import { Png } from "common/assets";
import { Config } from "common/config";
import { useResolution } from "common/hooks";
import { EColors } from "common/styles";
import { SpanColor } from "components/SpanColor";
import { Styled } from "components/Styled";
import { Fade } from "react-awesome-reveal";
import { ContentWrapper } from "./ContentWrapper";
import { ImageBonuse, StyledSectionBonuses } from "./styled";

export const Bonuses = () => {
  const { isMinScreen455 } = useResolution();
  return (
    <StyledSectionBonuses color={EColors.white} id={Config.Section.bonuses}>
      <Styled.ContainerWrapper>
        <Styled.Half>
          <Fade direction="left" triggerOnce>
            <Styled.H2>
              <SpanColor bgColor={EColors.primary_200}>Бонуси</SpanColor> за
              кожне заправлення: наша подяка вам
            </Styled.H2>
            <ContentWrapper />
          </Fade>
        </Styled.Half>
        <Styled.Half>
          <Fade direction="right" triggerOnce>
            <ImageBonuse
              src={isMinScreen455 ? `${Png.Bonuse}` : `${Png.BonuseMob}`}
              alt="car"
            />
          </Fade>
        </Styled.Half>
      </Styled.ContainerWrapper>
    </StyledSectionBonuses>
  );
};
